<div class="ymal-card-meta">
    <span *ngIf="mediaType" class="media-icon">
        <app-icon [type]="mediaType" class="selenium-card-media-type"></app-icon>
        <span class="text">{{ mediaType }}</span>
    </span>

    <div class="support-materials selenium-card-sm-icon" *ngIf="supportMaterialsCount">
        <app-icon
            ngbTooltip="{{ getToolTipText() }}"
            type="SupportMaterials"
            class="support-materials-icon"
        ></app-icon>
    </div>
</div>
